export default __webpack_public_path__ + "static/media/forestly-expl-nn-01_DE.4d217bea.png";